import { Link } from 'react-router-dom';
import { BsPencilSquare } from 'react-icons/bs';
import { GTMsendEvent } from '../../utils/trackingGA4'
import i18next from 'i18next';
import { ReporterStatusEnum, RoleEnum } from 'src/api/models/Enums';
import { UserDTO } from 'src/api';
import { useEffect, useState } from 'react';
import { MdOutlineNotificationsActive } from 'react-icons/md';
import { useAuth } from 'src/hooks/useAuth';

const ReporterStatus = ({ status }: { status: UserDTO['status'] }) => {
	const statusColor = {
		[ReporterStatusEnum.APPROVED]: 'green',
		[ReporterStatusEnum.PENDING]: 'orange',
		[ReporterStatusEnum.REJECTED]: 'red',
		[ReporterStatusEnum.UNKNOWN]: 'gray',
	}[status?.toUpperCase() || ReporterStatusEnum.UNKNOWN]

	const styles = {
		backgroundColor: statusColor,
		display: 'inline-block',
		marginLeft: 5,
		marginRight: 5,
		marginBottom: -2,
		borderRadius: '50%',
		borderStyle: 'solid',
		borderWidth: 0.5,
		borderColor: statusColor,
		height: 20,
		width: 20,
	};

	return <span style={styles} />
};

const NotificationIcon = ({ userDto }: { userDto: UserDTO }) => {
	const [isAnimating, setIsAnimating] = useState(false);
	const { userRole } = useAuth();

	useEffect(() => {
		setIsAnimating(true);
		const timer = setTimeout(() => {
			setIsAnimating(false);
		}, 2500);

		return () => clearTimeout(timer);
	}, []);

	const canSeeAlert = [
		RoleEnum.SALES,
		RoleEnum.SALES_DEALER,
	].includes(userRole);

	if (!canSeeAlert || !userDto.alert) {
		return null;
	}

	return (
		<div className="notification-icon">
			<MdOutlineNotificationsActive
				color="var(--cyan-color)"
				size={24}
				title={userDto.alert}
				className={`icon ${isAnimating ? 'animate' : ''}`}
			/>
		</div>
	);
};

export const columnsData = [
	{
		accessor: 'Alert',
		id: 'alert',
		Header: '',
		disableSortBy: true,
		Cell: ({ row }) => {
			return <NotificationIcon userDto={row.original} key={row.original?.username} />
		},
	},
	{
		accessor: 'username',
		id: 'username',
		Header: i18next.t('username'),
		minWidth: 290,
	},
	{
		accessor: 'given_name',
		id: 'given_name',
		Header: i18next.t('name'),
		width: 120,
	},
	{
		accessor: 'family_name',
		id: 'family_name',
		Header: i18next.t('surname'),
		width: 140,
	},
	{
		accessor: 'status',
		id: 'status',
		Header: i18next.t('reporter_status'),
		minWidth: 120,
		Cell: ({ value }) => {
			return (
				<>
					<ReporterStatus status={value} />
					{value ? i18next.t(value?.toLowerCase()) : 'Unknown'}
				</>
			)
		},
	},
	{
		accessor: 'phone',
		id: 'phone',
		Header: i18next.t('phone'),
		width: 120,
	},
	{
		accessor: 'actions',
		id: 'actions',
		Header: '',
		disableSortBy: true,
		headerClassName: 'column-sticky',
		className: 'column-sticky',
		width: 60,
		Cell: (data: any) => (
			<Link
				to={`/manage-users/${data.row.original.username}`}
				className="btn"
				onClick={() => {
					GTMsendEvent({
						event: 'CTA_modify_user',
						evtCat: 'user',
						evtAct: 'modify',
						evtLab: `modify_user`
					})
				}}
			>
				<BsPencilSquare
					style={{ width: '1.2rem', height: '1.6rem' }}
					name="edit"
				/>
			</Link>
		),
	},
];
